module.exports = __webpack_public_path__ + "static/almag-logo-56cf009d56e82a4926f437f420c8528e.png";